"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidDateHelpers = exports.formatDate = void 0;
const object_helpers_1 = require("./object.helpers");
const type_helpers_1 = require("./type.helpers");
function isDate(value) {
    return value instanceof Date && !isNaN(value.getTime());
}
function canBeCastToDate(value) {
    return !(0, type_helpers_1.isNullOrUndefined)(value) && !isNaN(new Date(value).getTime());
}
function canCastAllEntriesToDate(dataItems, dataPath) {
    return dataItems.every((dataItem) => canBeCastToDate((0, object_helpers_1.getAtPath)(dataItem, dataPath)));
}
/**
 * Format date to a locale based string
 * @param date the string representation of the date, should be in yyyy-mm-dd format
 * @param locale the locale to format the date to, when undefined it defaults to the browser locale
 * @param options the options to format the date with
 */
function formatDate(date, locale = undefined, options = { month: "2-digit", day: "2-digit", year: "numeric" }) {
    if (!canBeCastToDate(date)) {
        return "";
    }
    const dateString = (date === null || date === void 0 ? void 0 : date.includes("T")) ? date : `${date}T00:00:00.000`;
    return new Intl.DateTimeFormat(locale, options).format(new Date(dateString));
}
exports.formatDate = formatDate;
exports.FluidDateHelpers = {
    canCastAllEntriesToDate,
    canBeCastToDate,
    isDate
};
